/* unplugin-vue-components disabled */import { render } from "./postCardComp.vue?vue&type=template&id=66698f94&scoped=true"
import script from "./postCardComp.vue?vue&type=script&lang=js"
export * from "./postCardComp.vue?vue&type=script&lang=js"

import "./postCardComp.vue?vue&type=style&index=0&id=66698f94&scoped=true&lang=css"

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66698f94"]])

export default __exports__